<template>
	<main id="main" class="main">
		<section class="lists">
			<div class="inner">
				<div class="mobile_arrow left">
					<img class="search" src="../assets/arrow.svg" />
				</div>
				<div class="mobile_arrow right">
					<img class="search" src="../assets/arrow.svg" />
				</div>
				<div id="tablinks" class="tabs tablinks">
					<button
						@click="clickTablink(1, '10週年精選好文')"
						:class="{ active: tab_id == 1 }"
						class="tablink Sheet1_Click"
					>
						10週年精選好文
					</button>
					<button
						@click="clickTablink(2, '部落客好評推薦')"
						:class="{ active: tab_id == 2 }"
						class="tablink Sheet2_Click"
					>
						部落客好評推薦
					</button>
					<button
						@click="clickTablink(3, 'PIXNET網友口碑推薦')"
						:class="{ active: tab_id == 3 }"
						class="tablink Sheet3_Click"
					>
						PIXNET網友口碑推薦
					</button>
					<button
						@click="clickTablink(4, '精選文章')"
						:class="{ active: tab_id == 4 }"
						class="tablink Sheet4_Click"
					>
						精選文章
					</button>
				</div>
				<div class="cats tabcontent">
				<a
					v-for="i in article_data"
					:key="i.id"
					class="item"
					:href="i.link"
					target="_blank"
					rel="noreferrer noopener"
				>
					<div class="img">
					<img :src="i.image" />
					</div>
					<div class="description">
					<p>{{ i.title }}</p>
					</div>
				</a>
				</div>
			</div>
			<div 
				class="hamburger"
				@click="toggleSideTab()"
			>
			</div>
			<div 
				class="side_menu"
				:class="{ active: side_menu }"
			>
				<div class="top">
					<div 
						class="close"
						@click="toggleSideTab()"
					>
						<img src="../assets/close.svg" />
					</div>
				</div>
				<div
					@click="clickTablink(1, '10週年精選好文')"
					:class="{ active: tab_id == 1 }"
					class="tablink Sheet1_Click"
				>
					10週年精選好文
				</div>
				<div
					@click="clickTablink(2, '部落客好評推薦')"
					:class="{ active: tab_id == 2 }"
					class="tablink Sheet2_Click"
				>
					部落客好評推薦
				</div>
				<div
					@click="clickTablink(3, 'PIXNET網友口碑推薦')"
					:class="{ active: tab_id == 3 }"
					class="tablink Sheet3_Click"
				>
					PIXNET網友口碑推薦
				</div>
				<div
					@click="clickTablink(4, '精選文章')"
					:class="{ active: tab_id == 4 }"
					class="tablink Sheet4_Click"
				>
					精選文章
				</div>
			</div>
		</section>
		<section class="more-article">
			<button class="btn-more js-more-article Content_more_click" 
					v-show="article_counter<=article_max_page" 
					@click="getArticlesFromApi()">看更多文章</button>
		</section>
	</main>
</template>

<script>
import { getArticlesByTag } from "@/data/articleFallback";

export default {
	name: "MainComponent",
	data() {
		return {
			article_data: [],
			article_max_page: 0,
			article_counter: 1,
			page_size: 6,
			randomTab: [{id: 1, name: "10週年精選好文"}, 
						{id: 2, name: "部落客好評推薦"}, 
						{id: 3, name: "PIXNET網友口碑推薦"},
						{id: 4, name: "精選文章"}],
			tab_id: 1,
			tag_name: "",
			side_menu: false
		};
	},
	computed: {
		currentTabArticles() {
			return getArticlesByTag(this.tag_name);
		},
	},
	methods: {
		/*
			如果輸入數字，且數字小於等於總tab數量則指向指定該tab
			否則隨機
		*/
		constRandomTab(init_status) {
			if (init_status && init_status <= this.randomTab.length ) {
				this.tab_id = this.randomTab[init_status - 1].id;
				this.tag_name = this.randomTab[init_status - 1].name;
			} else {
				const random_num = Math.floor(Math.random() * 4);
				this.tab_id = this.randomTab[random_num].id;
				this.tag_name = this.randomTab[random_num].name;
			}
			
		},
		addArticleCount() {
			this.article_counter = this.article_counter + 1;
		},
		resetArticleCount() {
			this.article_counter = 1;
		},
		setArticleMaxPage(pages) {
			this.article_max_page = pages;
		},
		getArticlesFromApi() {
			const currentPage = this.article_counter;
			const startIndex = (currentPage - 1) * this.page_size;
			const nextArticles = this.currentTabArticles.slice(
				startIndex,
				startIndex + this.page_size
			);

			this.setArticleMaxPage(
				Math.ceil(this.currentTabArticles.length / this.page_size)
			);

			if (!nextArticles.length) {
				return;
			}

			this.article_data = [...this.article_data, ...nextArticles];
			this.addArticleCount();
		},
		toggleTagToGetArticle() {
			this.resetArticleCount();
			this.article_data = [];
			this.getArticlesFromApi();
		},
		clickTablink(id, tag_name) {
			if (this.tab_id != id) {
				this.tab_id = id;
				this.tag_name = tag_name;
				this.toggleTagToGetArticle();
			}
		},
		toggleSideTab(){
			this.side_menu = !this.side_menu;
		}
	},
	created() {
		this.constRandomTab(1);
	},
	mounted() {
		this.getArticlesFromApi();
	},
};
</script>
